import {Base} from "@/api/Base"

export class DepartmentEdit extends Base {
    path = "department/edit"
}